<template>
  <div class="page-container content-430 document-content">
    <EditorV5 v-if="showEditor" ref="editorV5" :show-toolbar="false" :editor-config-for-props="{placeholder:'',readOnly:true}"></EditorV5>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import commonApi from '@/request/common/index.js';
import EditorV5 from '@c/Base/EditorV5';
export default {
  // name: '',
  components: {
    EditorV5
  },
  data() {
    return {
      configType: 'MP_PARENT_USER_PROTOCOL',
      codeValue: '',
      showEditor: false

    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    this.configType = this.$route.query.type || 'MP_PARENT_USER_PROTOCOL';
    this.getDocument();
  },
  methods: {
    async getDocument() {
      const params = {
        configType: this.configType,
        orgId: '1'
      };
      const res = await commonApi.getConfigDocumentApi(params);
      if (res.status === 200 && res.message) {
        this.showEditor = true;
        this.$nextTick(() => {
          const { codeValue, codeName } = res.message;
          this.codeValue = codeValue;
          codeName ? this.$refs.editorV5.setEditorContext(codeName) : this.$refs.editorV5.setEditorContext('');
        });
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.document-content{
  width: 60vw;
  margin: 0 auto;
  /deep/.editor-box{
    border: none;
  }
}
</style>
